var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-app-qr-code"},[_c('qrcode-vue',{attrs:{"value":_vm.getUrl,"size":170,"level":"H","render-as":"svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }